export default __webpack_public_path__ + "static/tudor-goicea-5b6008f96d34e7b71e1f145f68ad6c7f.svg";